import { Component, Input, ViewChild, OnInit, Output, EventEmitter, TemplateRef, AfterViewInit, OnChanges, SimpleChanges, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ColumnMode, DatatableComponent, NgxDatatableModule, TableColumn } from '@swimlane/ngx-datatable';
import { NbSidebarService } from '@nebular/theme';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { CUSTOMER_PERMISSIONS, SERVICE_CENTER_PERMISSIONS } from '../../../constants';
import { FlightDeckQuery } from '../../../@core/akita-stores/stores/flightdeck/flightdeck.service';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as _ from 'lodash';

export interface CustomOpcodeTranslateTableColumnConfig extends TableColumn {
  align?: string;
  bold?: boolean;
  format?: string;
  detail?: boolean;
  customTemplate?: any;
  cellClass?: string;
  textWrap?: boolean;
  minWidth?: number;
  importModifyType?: boolean;
  checkbox?: boolean;
  cellAction?: {
    edit?: (row: any) => void;
    delete?: (row: any) => void;
  };
}

@Component({
  selector: 'custom-opcode-translate-table',
  templateUrl: './custom-opcode-translate-table.component.html',
  styleUrls: ['./custom-opcode-translate-table.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomOpcodeTranslateTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() type: string;
  @Input() rows: any[];
  @Input() cols: CustomOpcodeTranslateTableColumnConfig[];
  @Input() columnMode: string;
  @Input() paginationMode: any;
  @Input() pageInfo: any;
  @Input() isReception: boolean;
  @Input() expanded = false;
  @Input() hideShowNumberRows: boolean;
  @Input() scrollbarH: boolean;
  @Input() textHighlight: string = '';
  @Output() clickRow = new EventEmitter<any>();
  @Output() scroll = new EventEmitter<any>();
  @Output() sort = new EventEmitter<any>();
  @Output() resetSort = new EventEmitter<any>();
  @Output() buttonClick = new EventEmitter<any>();
  @Output() changePage = new EventEmitter<any>();
  @Output() changeLimit = new EventEmitter<any>();
  @Output() clickCell = new EventEmitter<any>();
  @Output('getValueExpand') rowExpand = new EventEmitter<any>();

  @ViewChild(DatatableComponent, { static: true }) ngxTable: DatatableComponent;

  ColumnMode = ColumnMode;
  pageSize: number = 10;
  enableCursorRow: boolean = true;
  scrollUpdate$;
  scrollCheck$;
  isScrolling: boolean = false;

  @Input()
  allSelectList = [];
  @Output()
  onRowSelectedChange = new EventEmitter<any>();
  rowSelectedList = new Map();

  constructor(
    private nbSidebarService: NbSidebarService,
    private router: Router,
    private permissionsService: NgxPermissionsService,
    public flightDeckQuery: FlightDeckQuery,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.handleLimitItem();
    if (changes.rows && changes.rows.currentValue) {
      this.expendRows();
    }
    if (changes.expanded && this.rows) {
      this.expendRows();
    }

    if (changes.rows && changes.rows.currentValue) {
      // this.rowSelected = _.cloneDeep(this.rows);
      setTimeout(() => {
        this.onRecaculate();
      }, 100)
    }

    if (changes.allSelectList && changes.allSelectList.currentValue) {
      setTimeout(() => {
        this.rowSelectedList.clear();
        this.selectAll();
      })
    }
  }

  private expendRows(): void {
    // if (this.expanded) {
    //   Promise.resolve().then(() => {
    //     this.ngxTable.rowDetail.expandAllRows();
    //   });
    // } else {
    //   Promise.resolve().then(() => {
    //     this.ngxTable.rowDetail.collapseAllRows();
    //   });
    // }

  }

  ngOnInit() {
    this.columnMode = this.columnMode && this.columnMode === "force" ? "force" : "flex";
    this.onRecaculate();
    this.nbSidebarService.onToggle().subscribe(() => {
      this.onRecaculate();
    });
    this.handleCursorRow();

    if (this.isReception) {
      this.scrollCheck$ = interval(30 * 1000).subscribe(() => {
        if (!this.isScrolling) {
          this.isScrolling = true;
          if (this.scrollUpdate$) this.scrollUpdate$.unsubscribe();
          this.scrollUpdate$ = this.updateScrollTimer().subscribe(() => {
            this.updateScrollPosition();
          });
        }
      })
    }


    setTimeout(() => {
      this.onRecaculate();
    }, 100)
  }

  onRecaculate() {
    setTimeout(() => {
      this.checkXScroll();
      this.ngxTable.recalculate();
      // window.dispatchEvent(new Event('resize'));
    }, 200);
  }

  onResize(event) {
    this.onRecaculate();
  }

  checkXScroll() {
    try {
      const tableWidth = this.ngxTable.element.getElementsByTagName('datatable-body')[0].clientWidth;
      const tableContentWidth = this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollWidth;
      const hasXScroll = this.ngxTable.element.getElementsByTagName('datatable-body')[0].classList.contains('hide-x-scroll');
      if (tableContentWidth <= (tableWidth + 15)) {
        !hasXScroll && this.ngxTable.element.getElementsByTagName('datatable-body')[0].classList.add('hide-x-scroll');
      } else {
        hasXScroll && this.ngxTable.element.getElementsByTagName('datatable-body')[0].classList.remove('hide-x-scroll');
      }
    } catch (error) { }
  }

  onActivate(event) {
    if (event.type == 'click') {
      event.cellElement.blur();
      this.clickRow.emit(event.row);
    }
  }

  handleClickCell(val) {
    this.clickCell.emit(val);
  }

  onScroll(event: number) {
    this.scroll.emit(event);
  }

  onSort(event) {
    this.sort.emit(event);
  }

  onResetSort(sorts: any[] = []) {
    this.ngxTable.sorts = sorts;
  }

  scrollToTop() {
    this.ngxTable.offset = 0;
  }

  handleCursorRow() {
    this.enableCursorRow = false;
  }

  toggleExpandRow(row, e, expanded) {
    this.rowExpand.emit({ row: row, event: e, expanded: expanded })
    e.stopPropagation();
    this.ngxTable.rowDetail.toggleExpandRow(row);
  }

  assignButton(row, e) {
    this.buttonClick.emit({ row: row, event: e });
  }

  setPage(event) {
    this.changePage.emit(event);
  }

  setLimitItem(limit) {
    this.changeLimit.emit(limit);
  }

  handleLimitItem() {
    if (this.paginationMode) {
      this.pageSize = this.pageInfo && this.pageInfo.limit ? this.pageInfo.limit : this.pageSize;
    } else {
      this.pageSize = undefined;
    }
  }

  getRowClass(row) {
    const showOverTime = !row.isReception && row.isOverTime;
    return {
      'has-hrefLink': !!row.hrefLink,
      'over-time': showOverTime,
      'normal': !showOverTime,
      'rowDisabled': row.rowDisabled,
    };
  }

  updateScrollTimer() {
    return interval(2 * 1000).pipe(takeWhile(() => this.isScrolling));
  }

  updateScrollPosition() {
    const scrollTop = this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollTop;
    const clientHeight = this.ngxTable.element.getElementsByTagName('datatable-body')[0].clientHeight;
    const scrollHeight = this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollHeight;
    const atBottom = scrollTop + clientHeight >= scrollHeight;

    if (!atBottom) {
      this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollTop = scrollTop + 50;
      this.isScrolling = true;
    } else {
      this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollTop = 0;
      this.isScrolling = false;
    }
  }

  showTextWithHighlight(text: string) {
    if (!text) return '--';

    const textHighlight = this.textHighlight.trim();
    if (!textHighlight) return text;
    const escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    const reg = new RegExp(escapeRegex(textHighlight), 'gi');
    const matchingText = text.match(reg);
    const matchingTextHighlight = matchingText ? matchingText[0] : '';

    return text.replace(reg, `<mark class="px-0">${matchingTextHighlight}</mark>`);
  }

  selectAll() {
    this.allSelectList.forEach((row, index) => {
      if (row.rowDisabled) return;
      this.rowSelectedList.set(index, row);
    });

    this.onRowSelectedChange.emit(Array.from(this.rowSelectedList.values()));
  }

  onSelectAllChange(event) {
    event.source.checked = false;

    if (this.isTableAllSelected()) {
      this.rowSelectedList.clear();
    } else {
      this.selectAll();
    }
  }

  isTableAllIndeterminate() {
    return this.rowSelectedList.size > 0 && !this.isTableAllSelected();
  }

  isTableAllSelected() {
    const availableSelectRowCount = this.allSelectList.filter(item => !item.rowDisabled).length || 0;
    if (availableSelectRowCount === 0) return false;
    return this.rowSelectedList.size === availableSelectRowCount;
  }

  onRowSelect(event) {
    if (this.allSelectList && this.allSelectList.length > 0)
    if (event.type !== 'click') return;
    if (_.get(event, 'row.rowDisabled')) return;
    setTimeout(() => {
      if (event.row) {
        if (this.rowSelectedList.has(event.row.rowIndex)) {
          this.rowSelectedList.delete(event.row.rowIndex);
        } else {
          this.rowSelectedList.set(event.row.rowIndex, event.row);
        }
        this.cdr.detectChanges();
      }

      this.onRowSelectedChange.emit(Array.from(this.rowSelectedList.values()));
    })

  }

  ngOnDestroy(): void {
    if (this.scrollUpdate$) this.scrollUpdate$.unsubscribe();
    if (this.scrollCheck$) this.scrollCheck$.unsubscribe();
  }
}
